import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoginPage       from './pages/LoginPage';
import DashboardPage   from './pages/DashboardPage';
import OrgsPage        from './pages/OrgsPage';
import OrgDetailPage   from './pages/OrgDetailPage';
import SystemAdminsPage from './pages/SystemAdminsPage';
import AuditLogPage    from './pages/AuditLogPage';
import BillingPage     from './pages/BillingPage';
import UserSearchPage  from './pages/UserSearchPage';
import SupportPage     from './pages/SupportPage';
import PlansPage          from './pages/PlansPage';
import SystemErrorsPage   from './pages/SystemErrorsPage';
import IntegrationsPage   from './pages/IntegrationsPage';
import ApiUsagePage       from './pages/ApiUsagePage';
import SecurityPage       from './pages/SecurityPage';
import DataAuditPage      from './pages/DataAuditPage';
import LatencyPage        from './pages/LatencyPage';

function Guard({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-base)' }}>
      <div className="spinner" />
    </div>
  );
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login"      element={<LoginPage />} />
      <Route path="/"           element={<Guard><DashboardPage /></Guard>} />
      <Route path="/orgs"       element={<Guard><OrgsPage /></Guard>} />
      <Route path="/orgs/:id"   element={<Guard><OrgDetailPage /></Guard>} />
      <Route path="/admins"     element={<Guard><SystemAdminsPage /></Guard>} />
      <Route path="/audit"      element={<Guard><AuditLogPage /></Guard>} />
      <Route path="/billing"    element={<Guard><BillingPage /></Guard>} />
      <Route path="/users"      element={<Guard><UserSearchPage /></Guard>} />
      <Route path="/support"    element={<Guard><SupportPage /></Guard>} />
      <Route path="/plans"      element={<Guard><PlansPage /></Guard>} />
      <Route path="/errors"     element={<Guard><SystemErrorsPage /></Guard>} />
      <Route path="/integrations"   element={<Guard><IntegrationsPage /></Guard>} />
      <Route path="/api-usage"       element={<Guard><ApiUsagePage /></Guard>} />
      <Route path="/security"        element={<Guard><SecurityPage /></Guard>} />
      <Route path="/data-audit"      element={<Guard><DataAuditPage /></Guard>} />
      <Route path="/latency"         element={<Guard><LatencyPage /></Guard>} />
      <Route path="*"           element={<Navigate to="/" replace />} />
    </Routes>
  );
}
